module.exports = __webpack_public_path__ + "img/otamerica_ar_spanish_2023_certification_badge.73ce0480.png";